var _path, _path2, _g, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#F1361D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_33232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 0H1.71429C0.767512 0 0 1.07452 0 2.4V21.6C0 22.9255 0.767512 24 1.71429 24H22.2857C23.2325 24 24 22.9255 24 21.6V2.4C24 1.07452 23.2325 0 22.2857 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_33232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2073 7.17283L15.2002 7.78573L15.2275 6.60714L14.6146 5.60009L15.7932 5.62734L16.8002 5.01444L16.773 6.19303L17.3859 7.20009L16.2073 7.17283ZM13.2495 3.91912L12.0874 3.72099L12.8812 2.84939L13.0793 1.68726L13.9509 2.48105L15.1131 2.67918L14.3193 3.55078L14.1211 4.71292L13.2495 3.91912ZM13.8341 14.3651L12.8491 15.0128L12.8352 13.834L12.1875 12.8489L13.3663 12.835L14.3514 12.1874L14.3653 13.3662L15.0129 14.3512L13.8341 14.3651ZM15.8613 11.1879L14.6896 11.3178L15.2124 10.2612L15.0825 9.08944L16.1392 9.61224L17.3109 9.48236L16.7881 10.539L16.918 11.7107L15.8613 11.1879Z",
    fill: "#FFDC42"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1494_33232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 0H1.71429C0.767512 0 0 1.07452 0 2.4V21.6C0 22.9255 0.767512 24 1.71429 24H22.2857C23.2325 24 24 22.9255 24 21.6V2.4C24 1.07452 23.2325 0 22.2857 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1494_33232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00013 9.87195L5.17876 11.8832L6.21975 8.57843L3.43506 6.51667L6.8998 6.48547L8.00013 3.19995L9.10046 6.48547L12.5652 6.51667L9.78051 8.57843L10.8215 11.8832L8.00013 9.87195Z",
    fill: "#FFDC42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.cd02cae0a61838b719ad0ca4cca48de2.svg";
export { ForwardRef as ReactComponent };